import KValidationProvider from "./KValidationProvider";
import { VSelect } from "vuetify/lib";

export default {
	name: "KSelect",

	extends: KValidationProvider,

	props: {
		...VSelect.options.props,

		color: {
			default: "link",
			type: String
		},

		itemColor: {
			default: "link",
			type: String
		}
	},

	computed: {
		propsToPass() {
			const props = {};

			Object.keys( this.$props ).forEach( prop => {
				if ( prop in VSelect.options.props ) {
					props[prop] = this.$props[prop];
				}
			} );

			return props;
		}
	},

	methods: {
		genValidatableField( props ) {
			return <VSelect
				attrs={{
					...this.$attrs,
					...this.propsToPass,
					errorMessages: props.errors
				}}
				on={{ ...this.$listeners }}
				scopedSlots={this.$scopedSlots}
				vModel={this.internalValue}
			>
				{Object.keys( this.$slots ).map( slot =>
					<template slot={slot} key={slot}>{this.$slots[slot]}</template>
				)}
			</VSelect>;
		}
	},

	render() {
		return this.genValidationProvider();
	}
};
